module.exports = __webpack_public_path__ + "img/msg-infocupo.3be5c0ca.svg";